import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const ONBOARDING_KEY = 'abaddon-onboarding-pending'

interface AuthState {
  token: string | null
  userId: string | null
  username: string | null
  emailVerified: boolean | null
  emailEnabled: boolean
  isSudo: boolean
  setAuth: (token: string, userId: string, username: string) => void
  clearAuth: () => void
  setEmailVerified: (verified: boolean) => void
  setEmailEnabled: (enabled: boolean) => void
  setIsSudo: (v: boolean) => void
  setNeedsOnboarding: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      userId: null,
      username: null,
      emailVerified: null,
      emailEnabled: false,
      isSudo: false,
      setAuth: (token, userId, username) => set({ token, userId, username, emailVerified: null, isSudo: false }),
      clearAuth: () => {
        sessionStorage.removeItem(ONBOARDING_KEY)
        set({ token: null, userId: null, username: null, emailVerified: null, isSudo: false })
      },
      setEmailVerified: (verified) => set({ emailVerified: verified }),
      setEmailEnabled: (enabled) => set({ emailEnabled: enabled }),
      setIsSudo: (v) => set({ isSudo: v }),
      setNeedsOnboarding: () => sessionStorage.setItem(ONBOARDING_KEY, '1'),
    }),
    { name: 'abaddon-auth' }
  )
)
